const mapClientToOptions = client => ({
    value: client.id,
    label: client.name,
});

export default mapClientToOptions;
